Vendd.Scripts.load(function () {

    var $boxes = $('.x-product-box-gtl');


    $.each($boxes, function (i, el) {
        var $wrapper = $(this),
            wrapper;
        var model = null;

        if ($wrapper.length < 1)
            return;

        wrapper = $wrapper.get(0);

    });
});
